import React, { useState, useEffect } from "react";
import { Button, Modal } from "antd";
import './coming-soon-popup.scss';

export default function ComingSoonPopup({ isOpen, onOk, onCancel }) {

  return (
    <Modal
      open={isOpen}
      title={<p class="coming-soon-title">Hang Tight, Explorer!</p>}
      onOk={onOk}
      onCancel={onCancel}
      maskClosable={true}
      className="coming-soon"
      footer={[
        <Button key="submit" onClick={onOk} className="coming-soon-btn">
          Got it
        </Button>,
      ]}
    >
      <div className="coming-soon-content">
        <p>
          <img className="coming-soon-img"
            src="images/popup-handbag.png"
            alt="popup-handbag"
          ></img>
        </p>
        <p>
          Hotels aren't live just yet. We're crafting the ultimate stay for your
          journey.
        </p>
      </div>
    </Modal>
  );
}
